var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visible ? _c('div', {
    staticClass: "common-tips-dialog",
    class: _vm.isMobile && 'common-tips-dialog-wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": function ($event) {
        _vm.outerCancel && _vm.cancelFn();
      }
    }
  }), _c('transition', {
    attrs: {
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    key: "dialog",
    staticClass: "dialog-main",
    style: {
      width: _vm.isMobile ? '90vw' : '50vw',
      maxWidth: _vm.isMobile ? '90vw' : '36%',
      height: 'auto',
      borderRadius: _vm.remTran(15)
    }
  }, [_c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "dialog-title"
  }, [_vm._v(_vm._s(_vm.$lang('通告')))]), _c('div', {
    staticClass: "split-line"
  }), _c('div', {
    staticClass: "dialog-tips"
  }, [_c('div', [_vm._v(_vm._s(_vm.$lang('RECT将于2025年4月30日正式启动去中心化的第二子生态——LUMA。')))]), _c('div', [_vm._v(_vm._s(_vm.$lang('RECT代币将在LUMA生态系统中启动通缩机制。')))]), _c('div', [_vm._v(_vm._s(_vm.$lang('LUMA机制采用100%分配模式。')))]), _c('div', [_vm._v(_vm._s(_vm.$lang('LUMA的财务将以去中心化方式执行。')))])]), _c('div', {
    staticClass: "split-line"
  }), _c('div', {
    staticClass: "dialog-actions"
  }, [_c('div', {
    staticClass: "dialog-button btn-confirm",
    on: {
      "click": _vm.confirmFn
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("Confirm")) + " ")]), _c('div', {
    staticClass: "dialog-button btn-cancel",
    on: {
      "click": _vm.cancelFn
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("Cancel")) + " ")])])])])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };